import {
  IEnvironment,
  TAdministrativeLevel,
  TLanguage,
  defaultEnvironment,
} from '@geovelo-frontends/commons';

import cvdlLogo from './assets/images/cvdl.svg';
import idfmLogo from './assets/images/idfm.svg';

let _environment: IEnvironment & {
  amplitude: { apiKey: string };
  config: {
    appTitle?: string;
    defaultCountryCode: string;
    defaultLanguage?: TLanguage;
    defaultZoneCode: string;
    enableCounts?: boolean;
    enableSHPDownload?: boolean;
    headerLogo?: string;
    maxAdministrativeLevel: Extract<TAdministrativeLevel, 'world' | 'country' | 'region'>;
    minAdministrativeLevel: Exclude<TAdministrativeLevel, 'world'>;
    resourceUrl?: string;
    partnerCode?: string;
    pdfDownload?: {
      administrativeLevel: TAdministrativeLevel;
      bucketUrl: string;
    };
    primaryColor?: string;
    useIDFMFacilitiesStyle?: boolean;
  };
} = {
  ...defaultEnvironment,
  source: '',
  apiKey: '3844e2ce-759a-4a43-b02b-b9b5630f2271',
  config: {
    maxAdministrativeLevel: 'country',
    minAdministrativeLevel: 'city',
    defaultCountryCode: 'fr',
    defaultZoneCode: 'île-de-france',
    enableCounts: true,
  },
  amplitude: { apiKey: 'cec4416362b670ccfaeee6198b6fbe05' },
};

if (process.env.REACT_APP_CONFIG === 'world') {
  _environment = {
    ..._environment,
    config: {
      ..._environment.config,
      maxAdministrativeLevel: 'world',
      minAdministrativeLevel: 'country',
    },
  };
} else if (process.env.REACT_APP_CONFIG === 'carto-velo') {
  _environment = {
    ..._environment,
    config: {
      ..._environment.config,
      appTitle: 'Carto Vélo | Île de France Mobilités',
      partnerCode: 'idfm',
      defaultLanguage: 'fr',
      primaryColor: '#25303b',
      maxAdministrativeLevel: 'region',
      minAdministrativeLevel: 'city',
      defaultCountryCode: 'fr',
      defaultZoneCode: 'île-de-france',
      enableCounts: false,
      headerLogo: idfmLogo,
      resourceUrl:
        "https://carto-velo.iledefrance-mobilites.fr/assets/pdf/Guide%20d'utilisation%20Site%20Cartovelo.pdf",
      enableSHPDownload: true,
      useIDFMFacilitiesStyle: true,
      pdfDownload: {
        administrativeLevel: 'epci',
        bucketUrl:
          !process.env.REACT_APP_ENV || process.env.REACT_APP_ENV === 'development'
            ? 'https://backend-dev.geovelo.fr/idfm'
            : 'https://backend.geovelo.fr/idfm',
      },
    },
  };
} else if (process.env.REACT_APP_CONFIG === 'carto-velo-cvdl') {
  _environment = {
    ..._environment,
    config: {
      ..._environment.config,
      appTitle: 'Carto Vélo | Centre Val de Loire',
      partnerCode: 'region-centre-val-de-loire',
      defaultLanguage: 'fr',
      primaryColor: '#03abe3',
      maxAdministrativeLevel: 'region',
      minAdministrativeLevel: 'city',
      defaultCountryCode: 'fr',
      defaultZoneCode: 'Centre-Val%20de%20Loire',
      enableCounts: false,
      headerLogo: cvdlLogo,
      // resourceUrl: "https://carto-velo.iledefrance-mobilites.fr/assets/pdf/Guide%20d'utilisation%20Site%20Cartovelo.pdf",
      pdfDownload: {
        administrativeLevel: 'epci',
        bucketUrl:
          !process.env.REACT_APP_ENV || process.env.REACT_APP_ENV === 'development'
            ? 'https://backend-dev.geovelo.fr/Centre-Val%20de%20Loire'
            : 'https://backend.geovelo.fr/Centre-Val%20de%20Loire',
      },
    },
  };
}

export const environment = _environment;
